import React from 'react';

import { DialogCloseButton } from '@wwe-portal/ui/components/dialog';

import { RosterDialog } from './roster-dialog';
import type { RosterFilterProps } from './roster-filter';
import { RosterFilter } from './roster-filter';

interface RosterFilterDialogProps {
  hidden: boolean;
  open: boolean;
  onClose: () => void;
  filterProps: RosterFilterProps | undefined;
  isLoading?: boolean;
}

export const RosterFilterDialog = ({
  open,
  hidden,
  onClose,
  filterProps,
}: RosterFilterDialogProps) => {
  if (filterProps == null) return null;
  return (
    <RosterDialog
      dataId="roster-filter-dialog"
      hidden={hidden}
      onClose={onClose}
      open={open}
    >
      <RosterFilter {...filterProps} />
      <DialogCloseButton onClose={onClose} />
    </RosterDialog>
  );
};
